import { apiClient } from './client';

/** A message to the logged-in user (e.g. "New work order assigned") */
export interface UserNotification {
  id: string;
  type: string;
  title: string;
  message: string | null;
  link: string | null;
  read_at: string | null;
  created_at: string;
}

const BASE = '/api/v1/notifications';

export async function getMyNotifications(): Promise<{ data: UserNotification[]; unread: number }> {
  const { data } = await apiClient.get(BASE);
  return { data: data.data || [], unread: Number(data.unread || 0) };
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(`${BASE}/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post(`${BASE}/read-all`);
}
